import { LatticeWindow } from '@bolteu/lattice/build/facade/Window';

declare const window: LatticeWindow;

export const getAppVersion = () => {
  const { appVersion, currentModule, currentModuleVersion } = window.Bolt?.Lattice ?? {};
  return {
    appVersion,
    moduleName: currentModule,
    moduleVersion: currentModuleVersion,
  };
};
